import { i18n } from '@apps/main/modules/localization/localizationSetup';

import type { AppSvgIconType } from '@libs/ui';
import type { GuestRatingBreakdown } from '@libs/trip-planner-interfaces';

import type { GuestRatingSummary } from '../../modules/customersRating';

const { t } = i18n.global;
export interface HotelReviews {
  overallScore: GuestRatingSummary | undefined;
  categories: ReviewItem[] | undefined;
}

interface RawReviewItem {
  key: string;
  title: string;
  icon: AppSvgIconType;
}

interface ReviewItem {
  title: string;
  score: string | null;
  icon: AppSvgIconType;
}

function getReviewCategoryData(
  hotelDetailsGuestRating: GuestRatingBreakdown
): ReviewItem[] {
  const categories: RawReviewItem[] = [
    {
      key: 'cleanliness',
      title: t('reviews.cleanliness'),
      icon: 'mop',
    },
    {
      key: 'service',
      title: t('reviews.service'),
      icon: 'concierge',
    },
    {
      key: 'comfort',
      title: t('reviews.comfort'),
      icon: 'sofa',
    },
    {
      key: 'condition',
      title: t('reviews.condition'),
      icon: 'building',
    },
    {
      key: 'location',
      title: t('reviews.location'),
      icon: 'distance',
    },
    {
      key: 'neighbourhood',
      title: t('reviews.neighbourhood'),
      icon: 'neighbourhood',
    },
    {
      key: 'quality',
      title: t('reviews.quality'),
      icon: 'quality',
    },
    {
      key: 'amenities',
      title: t('reviews.amenities'),
      icon: 'fileList',
    },
  ];

  return categories.reduce<ReviewItem[]>((result, { key, title, icon }) => {
    const rawScore = hotelDetailsGuestRating[key as keyof GuestRatingBreakdown];
    const score = getCategoryScore(rawScore);
    if (score !== null) {
      result.push({
        title,
        score,
        icon,
      });
    }
    return result;
  }, []);
}

function getCategoryScore(score: number | null): string | null {
  if (!score) {
    return null;
  }
  return `${score * 2} / 10`;
}

export function getHotelReviewCategoriessInfo(
  hotelDetailsGuestRating: GuestRatingBreakdown | undefined
): ReviewItem[] | undefined {
  if (!hotelDetailsGuestRating) {
    return;
  }
  const categories = getReviewCategoryData(hotelDetailsGuestRating);

  return categories;
}
